var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgVolumeOff(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 30,
    height: 30,
    viewBox: "0 0 30 30",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M6.63 6.2925C6.24 6.6825 6.24 7.3125 6.63 7.7025L10.29 11.3625L10 11.6625H7C6.45 11.6625 6 12.1125 6 12.6625V16.6625C6 17.2125 6.45 17.6625 7 17.6625H10L13.29 20.9525C13.92 21.5825 15 21.1325 15 20.2425V16.0725L19.18 20.2525C18.69 20.6225 18.16 20.9325 17.58 21.1625C17.22 21.3125 17 21.6925 17 22.0825C17 22.8025 17.73 23.2625 18.39 22.9925C19.19 22.6625 19.94 22.2225 20.61 21.6825L21.95 23.0225C22.34 23.4125 22.97 23.4125 23.36 23.0225C23.75 22.6325 23.75 22.0025 23.36 21.6125L8.05 6.2925C7.66 5.9025 7.03 5.9025 6.63 6.2925ZM22 14.6625C22 15.4825 21.85 16.2725 21.59 17.0025L23.12 18.5325C23.68 17.3625 24 16.0525 24 14.6625C24 10.8325 21.6 7.5525 18.22 6.2625C17.63 6.0325 17 6.4925 17 7.1225V7.3125C17 7.6925 17.25 8.0225 17.61 8.1625C20.18 9.2025 22 11.7225 22 14.6625ZM13.29 8.3725L13.12 8.5425L15 10.4225V9.0725C15 8.1825 13.92 7.7425 13.29 8.3725ZM19.5 14.6625C19.5 12.8925 18.48 11.3725 17 10.6325V12.4225L19.48 14.9025C19.49 14.8225 19.5 14.7425 19.5 14.6625Z",
    fill: "white"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgVolumeOff);
export default __webpack_public_path__ + "static/media/volume_off.8ab409a53d5f59bde2cc7804ac8418f6.svg";
export { ForwardRef as ReactComponent };